var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"play","d":"M37.621,14.043,17.842.2A1.031,1.031,0,0,0,16.613.21,1.639,1.639,0,0,0,16,1.539V29.23a1.639,1.639,0,0,0,.613,1.329,1.066,1.066,0,0,0,.623.209,1.049,1.049,0,0,0,.606-.2l19.78-13.846a1.742,1.742,0,0,0,0-2.683Z","transform":"translate(-16 0)","fill":"#583ba8"}));
}

PlayInline.defaultProps = {"width":"22.252","height":"30.768","viewBox":"0 0 22.252 30.768"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
